import { Flex, Typography } from "antd"

export const OnRampWidgetStepUi = () => {
  return (
    <Flex vertical>
      <Typography.Text>
        In the On-Ramp Widget section, you can generate the HTML code for a
        widget that allows users to buy cryptocurrency with Visa/Mastercard.
      </Typography.Text>

      <ul>
        <li>The widget can be embedded on your website for free. </li>
        <li>You can earn from the markup on the exchange rate.</li>
      </ul>

      <Typography.Text>
        For detailed terms and conditions, please contact your Account Manager.
      </Typography.Text>
    </Flex>
  )
}
